import Vue from 'vue'
import Router from 'vue-router'
import {PS_ROUTES} from '~common/commonModule/passport/router/index.js'
Vue.use(Router)

let routes = []

routes = routes.concat(PS_ROUTES)

const router = new Router({
    mode: 'history',
    routes: routes
})
router.beforeEach((to, from, next) => {
    let sUserAgent = navigator.userAgent.toLowerCase()
    let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    let bIsMidp = sUserAgent.match(/midp/i) == "midp";
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    let bIsAndroid = sUserAgent.match(/android/i) == "android";
    let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (to.meta.title) {
        document.title = to.meta.title
    }else{
        document.title = "好未来帐号安全中心"
    }
    if ((bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
        //跳转移动端页面
        if (to.path.indexOf('touch') < 0) {
            if (to.path == '/helpCenter' && !Object.keys(to.query).length) {
                // 帮助中心列表
                next({path: '/touch/helpCenterList'})
            } else {
                next({path: `/touch${to.path}`, query: to.query,params: to.params})
            }
        } else {
            next()
        }
    } else{
        //跳转pc端页面
        if (to.path.indexOf('touch') > -1) {
            let str = to.path.substr(6)
            if (str == '/helpCenterList') {
                // 帮助中心列表
                next({path: '/helpCenter'})
            } else {
                next({path:str, query: to.query,params: to.params})
            }
        } else {
            next()
        }
    }
})
export default router



// WEBPACK FOOTER //
// ./module/passport/src/router/index.js